// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__dFkLD","sendOtp":"AuthorizeToLogin_sendOtp__2MBmi"};